<template>
  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="产品与库存名称">
          <el-input placeholder="请输入产品与库存名称" v-model="formInline.search">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加产品与库存</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
      
            <el-table-column prop="name" label="产品与库存名称"></el-table-column>
            <el-table-column prop="sku" label="sku编号"></el-table-column>
            <el-table-column prop="contact" label="联系人"></el-table-column>
            <el-table-column prop="phone" label="电话"></el-table-column>
            
            <!-- 审核状态 -->
            <el-table-column prop="audit_status" label="审核状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="getAuditStatusType(scope.row.audit_status)" size="small">
                  {{ getAuditStatusText(scope.row.audit_status) }}

                </el-tag>
              </template>
            </el-table-column>

            <el-table-column prop="sort" label="排序"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column prop="status" label="是否启用">
              <template slot-scope="scope">
                <el-switch
                  @change="setStatus(scope.row)"
                  v-model="scope.row.status"
                  active-color="#13ce66"
                  inactive-color="#c0c4cc"
                  :active-value="1"
                  :inactive-value="0"
                >
                </el-switch>
              </template>
            </el-table-column>
            <!-- 操作列 -->
            <el-table-column fixed="right" label="操作" width="180">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button 
                  @click="auditClick(scope.row)" 
                  type="text" 
                  size="small"
                  class="member-btn"
                  :disabled="scope.row.audit_status === 1"
                >
                  {{ scope.row.audit_status === 1 ? '已审核' : '审核' }}
                     <span v-if="scope.row.is_read == 0" class="unread-dot-member"></span>
                </el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add" @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :product_cp_id="product_cp_id" v-if="open_edit" @close="closeEdit"></Edit>

    <el-dialog style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
      :close-on-click-modal="false" 
      :close-on-press-escape="false" 
      :append-to-body="true">
    </el-dialog>
  </div>
</template>

<script>
  import Product_cpaApi from '@/api/product_cpa.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:""
        },

        open_add:false,
        open_edit:false,
        product_cp_id:"",
        dialogVisible:false,
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();
    },
  //  beforeDestroy(){
  //    SupplyApi.project_investment_read({
  //     }).then(res=>{
  //     })
  //  },
    methods: {
      setStatus(item) {
        let self = this;
        const originalStatus = item.status;
        const isOpen = item.status === 1;
        const confirmText = isOpen ? '确认开启吗？' : '确认关闭吗？';

        self.$confirm(confirmText, '操作确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          let form = {
            'product_cp_id': item.product_cp_id,
            'status': item.status
          };
          Product_cpaApi.setStatus(form, true)
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                const successText = isOpen ? '开启成功' : '关闭成功';
                self.$message({ message: successText, type: 'success' });
                self.getTableList();
              } else {
                self.loading = false;
                item.status = originalStatus;
                self.$message.error('操作失败，请重试');
              }
            })
            .catch(error => {
              self.loading = false;
              item.status = originalStatus;
              self.$message.error('操作失败，请重试');
            });
        }).catch(() => {
          // 关键修复：用$nextTick确保视图同步还原
          this.$nextTick(() => {
            // item.status = originalStatus;
            this.getTableList();
            const cancelText = isOpen ? '已取消开启操作' : '已取消关闭操作';
            self.$message({ type: 'info', message: cancelText });
          });
        });
      },
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//产品与库存标题设置
        this.dialogVisible = true;
      },
      /*关闭添加*/
      closeAdd(e){
        this.open_add=false;
        this.getTableList();
      },
      closeEdit(e){
        this.open_edit=false;
        this.getTableList();
      },
      getData(){
        this.getTableList();
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        Product_cpaApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*审核按钮点击事件*/
      auditClick(row) {
        let self = this;
        self.$confirm('确定要审核通过该产品吗?', '审核确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          Product_cpaApi.audit({
            product_cp_id: row.product_cp_id
          }, true)
          .then(data => {
            if (data.code == 1) {
              self.$message({
                message: '审核成功',
                type: 'success'
              });
              this.getTableList();
            } else {
              self.$message.error('审核失败：' + data.msg);
            }
          })
          .catch(error => {
            self.$message.error('审核请求失败');
          });
        })
        .catch(() => {
          // 用户取消审核
        });
      },

      /*获取审核状态文本*/
      getAuditStatusText(status) {
        const statusMap = {
          0: '待审核',
          1: '已审核',
          2: '审核驳回'
        };
        return statusMap[status] || '未知状态';
      },

      /*获取审核状态标签类型*/
      getAuditStatusType(status) {
        const typeMap = {
          0: 'warning',  // 待审核 - 黄色
          1: 'success',  // 已审核 - 绿色
          2: 'danger'    // 审核驳回 - 红色
        };
        return typeMap[status] || 'info';
      },

      /*获取库存状态文本*/
      getInventoryText(status) {
        const statusMap = {
          0: '库存紧张',
          1: '库存充足',
          2: '缺货'
        };
        return statusMap[status] || '未知状态';
      },

      /*获取库存状态标签类型*/
      getInventoryType(status) {
        const typeMap = {
          0: 'warning',  // 库存紧张 - 黄色
          1: 'success',  // 库存充足 - 绿色
          2: 'danger'    // 缺货 - 红色
        };
        return typeMap[status] || 'info';
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.product_cp_id = row.product_cp_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          Product_cpaApi.del({
            product_cp_id: row.product_cp_id
          }, true)
          .then(data => {
            if (data.code == 1) {
              self.$message({
                message: '删除成功',
                type: 'success'
              });
              this.getTableList();
            } else {
              self.$message.error('错了哦，这是一条错误消息');
            }
          })
          .catch(error => {
          });
        })
        .catch(() => {
        });
      }
    }
  };
</script>

<style>
  /* 可以添加一些自定义样式 */
  .el-table .cell {
    text-align: center;
  }
  .member-btn {
  position: relative;
}

/* 会员未读红点样式 */
.unread-dot-member {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 8px;
  height: 8px;
  background-color: #ff4757;
  border-radius: 50%;
  animation: pulse 2s infinite;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/product_cp/index/index.vue